import {useNavigationGuardContext} from './useRegisterNavigationGuard';

function useGuardedNavigate() {
  return useNavigationGuardContext().guardedNavigate;
}

export {useGuardedNavigate};
